// 'use client';
import {
  HomeFastContextProvider,
  ReportFastContextProvider
} from '@ninjacart/nc-nk-store';
import { ReportBottomSheet } from '@ninjacart/nc-nk-ui';
import { HomeFeed } from './components/home';

export const Home = ({ initialData }: { initialData?: any }) => {
  return (
    <ReportFastContextProvider>
      <HomeFastContextProvider>
        <HomeFeed initialData={initialData} />
      </HomeFastContextProvider>
      <ReportBottomSheet />
    </ReportFastContextProvider>
  );
};
